import * as types from "../constants";

const themes = {
  // Palette TRC (refonte 10/2026) : encre, rouge TRC, gris — mêmes couleurs que le thème SCSS.
  corporate: {
    primary: "#111111",
    secondary: "#4a525a",
    tertiary: "#c03b19",
    success: "#22a45d",
    info: "#3a8fb7",
    warning: "#f0a500",
    danger: "#c03b19"
  },
  modern: {
    primary: "#2c7be5",
    secondary: "#9d7bd8",
    tertiary: "#5997eb",
    success: "#4caf50",
    info: "#47bac1",
    warning: "#ff9800",
    danger: "#e51c23"
  },
  classic: {
    primary: "#47bac1",
    secondary: "#a180da",
    tertiary: "#5fc27e",
    success: "#5fc27e",
    info: "#5b7dff",
    warning: "#fcc100",
    danger: "#f44455"
  }
};

const initialState = {
  currentTheme: themes.corporate,
  themes: themes
};

export default function reducer(state = initialState, actions) {
  switch (actions.type) {
    case types.THEME_TOGGLE:
      return {
        ...state,
        currentTheme: state.themes[actions.payload]
      };

    default:
      return state;
  }
}
